import { TableHeader } from '../../../Components/Tables/Table/TableDefinitions';
import languageService from '../../../Services/Language/LanguageService';
import { translationKeys } from '../../../Services/Language/TranslationDefinitions';
import styles from './InsuranceQuoteEstimator.module.scss';

export type CoverageTableRow = {
    isKey: boolean;
    isVisible: boolean | undefined;
    endorsementLength: JSX.Element | null;
    endorsementLengthRawValue: number;
    asOfDate: string;
    endCoverageDate: string;
    expectedValue: number;
    commodityType: string;
    coverageLevelPercent: number;
    coveragePrice: number;
    rate: number;
    insuredValue: number;
    totalPremium: number;
    subsidy: number;
    producerPremium: number;
    producerCostPerHundredWeight: number;
    producerCostPerHead: number;
};

const largeValueSignificantDigits = 0;

export const coverageTableHeaders: TableHeader<CoverageTableRow>[] = [
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.endorsementLength),
        className: styles.coverage_levels_table_headers_cell_endorsement_length,
        field: 'endorsementLengthRawValue',
        elementField: 'endorsementLength',
        dataFormat: 'element',
        minimumWidth: 100,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.type),
        className: styles.coverage_levels_table_headers_cell_type,
        field: 'commodityType',
        dataFormat: 'string',
        minimumWidth: 150,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.effectiveDate),
        className: styles.coverage_levels_table_headers_cell_end_date,
        field: 'asOfDate',
        dataFormat: 'string',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.endCoverageDate),
        className: styles.coverage_levels_table_headers_cell_end_date,
        field: 'endCoverageDate',
        dataFormat: 'string',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.expectedValue),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'expectedValue',
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.coverageLevel),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'coverageLevelPercent',
        dataFormat: 'percent',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.coveragePrice),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'coveragePrice',
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.rate),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'rate',
        dataFormat: 'currency',
        displayDecimalPlaces: 5,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.insuredValue),
        className: styles.coverage_levels_table_headers_cell_insured_value,
        field: 'insuredValue',
        dataFormat: 'currency',
        displayDecimalPlaces: largeValueSignificantDigits,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.totalPremium),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'totalPremium',
        dataFormat: 'currency',
        displayDecimalPlaces: largeValueSignificantDigits,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.subsidy),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'subsidy',
        dataFormat: 'currency',
        displayDecimalPlaces: largeValueSignificantDigits,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.producerPremium),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'producerPremium',
        dataFormat: 'currency',
        displayDecimalPlaces: largeValueSignificantDigits,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.producerCostPerHundredWeight),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'producerCostPerHundredWeight',
        dataFormat: 'currency',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.risk.margin.headers.producerCostPerHead),
        className: styles.coverage_levels_table_headers_cell_number,
        field: 'producerCostPerHead',
        dataFormat: 'currency',
    },
];
